import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { primarySpreadsheetIdSelector } from '../mapInfo/mapInfo.selectors';

export const usePrimarySpreadsheetId = () => {
  return useSelector(primarySpreadsheetIdSelector);
};
